angular.module('AccountingBoxApp')
  .controller('MainCtrl', function ($scope, $http, Purchase) {
  //  $scope.awesomeThings = [];
    //$scope.purchases = [];
    //var purchase = $cachedResource('purchase', '/api/purchases',{id: '@id'});
//    $scope.isEditing = false;
      var vm = this;
   var purchases = Purchase.find();
   console.log(Purchase.modelName);
  purchases.$promise.then(function() {
   console.log('From cache:', purchases);
   vm.purchases = purchases;
  });
  vm.purchases = purchases;
  console.log('From server:', purchases);
  vm.detail = function(id){
    console.log(id);
    vm.purchase = Purchase.get({'id':id});
    console.log(vm.purchase);
  };

  });
